<div class="lang-switcher">
  <div class="lang-switcher__dropdown" *ngIf="open">
    <div
      class="lang-switcher__option"
      *ngFor="let lang of languages"
      [class._active]="lang.code === activeLang.code"
      (click)="select(lang)"
    >
      <span class="lang-switcher__flag">{{ lang.flag }}</span>
      <span class="lang-switcher__name">{{ lang.name }}</span>
    </div>
  </div>

  <button class="lang-switcher__trigger" (click)="toggle()">
    <span class="lang-switcher__flag">{{ activeLang.flag }}</span>
    <span class="lang-switcher__name">{{ activeLang.name }}</span>
    <span class="lang-switcher__chevron" [class._open]="open">›</span>
  </button>
</div>
